<template>
  <el-tag ref="ElTagDict" :type="judgeType" v-on="$listeners" v-bind="$attrs">
    <template
      v-for="(slot, key) in $scopedSlots"
      :slot="key"
      slot-scope="scope"
    >
      <slot :name="key" v-bind="scope"></slot>
    </template>
    <template v-for="(slot, key) in $slots" :slot="key">
      <slot :name="key"></slot>
    </template>
    {{GetLabelByCodeFilter(value, dictType)}}
  </el-tag>
</template>

<script>
import {GetLabelByCodeFilter} from "~/filters/dict"
export default {
  name: "el-tag-dict",
  props: {
    value: {

    },
    dictType: {
      type: [String],
      required: true
    }, //请求的码表值
    judgeTypeFun: {
      type: Function,
      default: () => {

      }
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  data() {
    return {
      GetLabelByCodeFilter
    }
  },
  computed: {
    judgeType() {
      if (!this.judgeTypeFun) {
        return this.type
      }
      return this.judgeTypeFun(this.value) || this.type
    }
  },
  getRef() {
    return this.$refs.ElTagDict
  }
}
</script>

<style>

</style>